import React, { useEffect, useState, useContext } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";
import Pagination from "@mui/material/Pagination";
import SessionsApi from "../../../../../Classes/API/Administration/SessionsApi";
import DataTable from "examples/Tables/DataTable";
import SearchSingleSessions from "./SearchSingleSessions";
import { UserContext } from "App";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const Index = ({ SetAccSession }) => {
  const CurrentUser = useContext(UserContext);
  const navigate = useNavigate();
  const [Page, setPage] = useState(1);
  const [PaginationPages, setPaginationPages] = useState(0);
  const [TableDataRows, setTableDataRows] = useState([]);
  const [SearchReq, setSearchReq] = useState({
    noAppointmentOnly: true,
    pagingParams: { pageSize: 6, pageNumber: 1 },
  });

  // RESTORED ALL COLUMNS
  const TableColumns = [
    { Header: "Add", accessor: "Action", align: "center", width: "5%" },
    { Header: "ID", accessor: "Id", align: "left" },
    { Header: "Session", accessor: "Session", align: "left" },
    { Header: "Patient", accessor: "Patient", align: "left" },
    { Header: "Therapist", accessor: "Therapist", align: "left" },
    { Header: "Time", accessor: "Time", align: "left" },
    { Header: "Paid", accessor: "PaidFor", align: "center" },
    { Header: "Exc.", accessor: "Exception", align: "center" },
    { Header: "Adm.", accessor: "Admitted", align: "center" },
    { Header: "Details", accessor: "Edit", align: "center" },
  ];

  const GetOptions = (session) => {
    const allowedRoles = [
      "Admin", "Owner", "HeadAccounting",
      "Therapist",
      "AccountingEmployee",
      "AppointmentEmployee",
      "CallCenterEmployee",
    ];
    if (!allowedRoles.includes(CurrentUser.userType)) {
      Swal.fire(
        "Access Denied",
        "Visit your admin to request permission.",
        "error",
      );
      return;
    }
    navigate("/AccountingSessions/Details", {
      state: { SearchSession: session },
    });
  };

  const GetTableData = async () => {
    const req = {
      ...SearchReq,
      pagingParams: { ...SearchReq.pagingParams, pageNumber: Page },
    };
    const res = await SessionsApi.SearchAccountingSessions(req);

    if (res.status === "Success") {
      setPaginationPages(res.data.totalPages);
      const rows = res.data.list.map((session) => {
        const isDisabled =
          (!["Admin", "Owner", "HeadAccounting"].includes(CurrentUser.userType)) && session.isAdmitted;

        return {
          Action: (
            <IconButton
              size="small"
              color="info"
              onClick={() => SetAccSession(session)}
              disabled={isDisabled}
            >
              <Icon>add_circle</Icon>
            </IconButton>
          ),
          Id: (
            <MDTypography variant="caption" fontWeight="bold">
              {session.id}
            </MDTypography>
          ),
          Session: (
            <MDTypography variant="caption">{session.sessionName}</MDTypography>
          ),
          Patient: (
            <MDTypography variant="caption">{session.patientName}</MDTypography>
          ),
          Therapist: (
            <MDTypography variant="caption">
              {session.therapistName || "N/A"}
            </MDTypography>
          ),
          Time: (
            <MDTypography variant="caption">
              {session.appointmentTime || "---"}
            </MDTypography>
          ),
          PaidFor: session.isPaidFor ? (
            <CheckCircleIcon color="success" sx={{ fontSize: 18 }} />
          ) : (
            <RadioButtonUncheckedIcon color="disabled" sx={{ fontSize: 18 }} />
          ),

          Exception: session.isException ? (
            <ReportProblemIcon color="warning" sx={{ fontSize: 18 }} />
          ) : (
            <RadioButtonUncheckedIcon color="disabled" sx={{ fontSize: 18 }} />
          ),

          Admitted: session.isAdmitted ? (
            <LockIcon color="info" sx={{ fontSize: 18 }} />
          ) : (
            <LockOpenIcon color="disabled" sx={{ fontSize: 18 }} />
          ),

          Edit: (
            <IconButton size="small" onClick={() => GetOptions(session)}>
              <MoreVertIcon fontSize="small" />
            </IconButton>
          ),
        };
      });
      setTableDataRows(rows);
    }
  };

  useEffect(() => {
    GetTableData();
  }, [Page]);

  return (
    <MDBox sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <SearchSingleSessions
        setSearchReq={setSearchReq}
        GetTableData={GetTableData}
      />
      <MDBox sx={{ flex: 1, overflow: "hidden", px: 1 }}>
        <DataTable
          table={{ columns: TableColumns, rows: TableDataRows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>
      <MDBox display="flex" justifyContent="center" p={1}>
        <Pagination
          count={PaginationPages}
          page={Page}
          color="primary"
          size="small"
          onChange={(e, num) => setPage(num)}
        />
      </MDBox>
    </MDBox>
  );
};

export default Index;
